module.exports = __webpack_public_path__ + "components/resort-webcams/static/icon--player-13426ae98ab8aefcad39f04eef3634e1.svg";